import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { optionalSession } from "@/app/optional-session"
import { AuthPanel } from "@/components/layout/auth-panel"

export const Route = createFileRoute("/$organisation/_guest")({
  beforeLoad: async ({ context, params }) => {
    if (await optionalSession(context.queryClient)) {
      throw redirect({
        to: "/$organisation",
        params: { organisation: params.organisation },
      })
    }
  },
  component: GuestLayout,
})

function GuestLayout() {
  const { brand } = Route.useRouteContext()

  return (
    <AuthPanel brand={brand}>
      <Outlet />
    </AuthPanel>
  )
}
